import { useEffect, useRef } from "react";
import { track } from "../../../lib/analytics";

const THRESHOLDS = [25, 50, 75, 100] as const;

/**
 * Track la profondeur de scroll sur la landing page.
 * Envoie un événement unique par palier atteint (25%, 50%, 75%, 100%).
 */
export function useScrollDepth() {
  const firedRef = useRef(new Set<number>());

  useEffect(() => {
    const fired = firedRef.current;

    function handleScroll() {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;

      const percent = Math.round((scrollTop / docHeight) * 100);

      for (const threshold of THRESHOLDS) {
        if (percent >= threshold && !fired.has(threshold)) {
          fired.add(threshold);
          track("landing_scroll_depth", { depth: threshold });
        }
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
}
